import { render } from "./혈압_결과.vue?vue&type=template&id=7b3b1131"
import script from "./혈압_결과.vue?vue&type=script&lang=js"
export * from "./혈압_결과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__